import { defineStore } from 'pinia'
import { ref } from 'vue'

const MUTATING = ['post', 'put', 'patch', 'delete']

export const useMaintenanceStore = defineStore('maintenance', () => {
  const active = ref(false)

  // Single place the axios interceptor feeds status codes into. State/decisions
  // only — UI side effects (snackbar, redirect) live in the interceptor/router.
  // 503 + X-Maintenance header → MaintenanceMiddleware (intentional maintenance).
  // 503 without the header (Graph passthrough, health 503 on a normal call) → clear.
  // Any other real HTTP status → backend is responding normally.
  // null/undefined status (network error) → leave state unchanged.
  // Mutations (POST/PUT/PATCH/DELETE) during maintenance return true so the
  // interceptor shows the error snackbar and tags the error (user stays on the
  // form and can retry); GETs flip `active` for the full-screen redirect.
  const noteStatus = (status, headers, method) => {
    if (status === 503 && headers?.['x-maintenance']) {
      if (MUTATING.includes(String(method || '').toLowerCase())) {
        return true
      }
      active.value = true
    } else if (typeof status === 'number') {
      active.value = false
    }
    return false
  }

  return { active, noteStatus }
})
